<template>
  <div class="alert-box">
    <!-- <img src="../../assets/images/logo.png" class="alert-logo" />
    <div class="alert-app-name">微诺亚APP</div>
    <div class="alert-slogon">您手边的理财专家</div>
    <a
      href="https://a.app.qq.com/o/simple.jsp?pkgname=com.noahwm.android&from=singlemessage&isappinstalled=1"
      class="alert-btn"
    >下载</a> -->
    <div class="alert-tips">
      感谢您的信任，我们将尽快安排专属顾问与您联系，
    </div>
    <div class="alert-tips">请您保持电话畅通。</div>
    <img
      src="../../assets/images/close.png"
      class="alert-close"
      @click="$emit('close-modal')"
    />
  </div>
</template>

<script>
export default {
  name: "mobile-success"
}
</script>

<style lang="less" scoped>
.mobile {
  .modal-wrapper {
    .alert-box {
      width: 6.7rem;
      height: 9rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding-top: 7.75rem;
      box-sizing: border-box;
      border-radius: 0.2rem;
      background: #fff left top / 6.7rem
      url("../../assets/images/successAlertBg.png") no-repeat;
    }

    .alert-box .alert-close {
      position: absolute;
      width: 0.54rem;
      left: 50%;
      transform: translateX(-50%);
      bottom: -0.79rem;
    }

    .alert-box .alert-logo {
      width: 1.4rem;
      height: 1.4rem;
      position: absolute;
      left: 0.6rem;
      top: 1.4rem;
    }

    .alert-box .alert-app-name {
      width: 1.8rem;
      height: 0.48rem;
      line-height: 0.48rem;
      position: absolute;
      left: 2.2rem;
      top: 1.66rem;
      font-size: 0.34rem;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #ffffff;
    }

    .alert-box .alert-slogon {
      width: 2.3rem;
      height: 0.4rem;
      line-height: 0.4rem;
      position: absolute;
      left: 2.2rem;
      top: 2.14rem;
      font-size: 0.28rem;
      color: #ffffff;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .alert-box .alert-btn {
      width: 1.2rem;
      height: 0.5rem;
      line-height: 0.5rem;
      position: absolute;
      left: 4.9rem;
      top: 1.85rem;
      border: 0.02rem solid #ffffff;
      border-radius: 0.25rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      display: block;
      text-decoration: none;
      text-align: center;
    }

    .alert-tips {
      width: 5.62rem;
      height: 0.34rem;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #e3bb98;
      line-height: 0.34rem;
      text-align: center;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resultModal/mobile-success.vue